import React, { useEffect, useRef } from 'react'
import { AddTapsToRunToGoalV2Zone } from './../../../utilities/BL/RunToGoal'

// =========================================================================
// DICCIONARIO DE MÁSCARA VISUAL (Traductor de Zonas)
// =========================================================================
const getVisualZoneNameWithRole = (realZoneName) => {
    if (!realZoneName) return '';
    const normalized = realZoneName.toLowerCase().trim();

    const aliases = {
        'zona1': 'Zona Oriente (local)',
        'zona 1': 'Zona Oriente (local)',
        'zona oriente': 'Zona Oriente (local)',
        'zona oriente (local)': 'Zona Oriente (local)',
        'oriente': 'Zona Oriente (local)',
        'noa local': 'Zona Oriente (local)',
        'team noa local': 'Zona Oriente (local)',
        '1': 'Zona Oriente (local)',
        'lucho': 'Zona Oriente (local)',
        'team lucho': 'Zona Oriente (local)',

        'zona2': 'Zona Poniente (visitante)',
        'zona 2': 'Zona Poniente (visitante)',
        'zona poniente': 'Zona Poniente (visitante)',
        'zona poniente (visitante)': 'Zona Poniente (visitante)',
        'poniente': 'Zona Poniente (visitante)',
        'noa visitante': 'Zona Poniente (visitante)',
        'team noa visitante': 'Zona Poniente (visitante)',
        '2': 'Zona Poniente (visitante)',
        'tunita': 'Zona Poniente (visitante)',
        'team tunita': 'Zona Poniente (visitante)'
    };

    return aliases[normalized] || realZoneName;
};

const getVisualZoneNameWithoutRole = (realZoneName) => {
    if (!realZoneName) return '';
    const withRole = getVisualZoneNameWithRole(realZoneName);
    return withRole.replace(/\s*\([^)]*\)/g, '').trim();
};

const GoalV2 = ({ matchState, config, winnerZone, userZone }) => {
    const currentPhase = matchState?.phase || 'WAITING';
    const activeMatchIdentifier = matchState?.matchId;

    const tapsBatchSize = config?.tapsPorTick || 10;
    const minimumFlushTimeMilliseconds = config?.minUpdateMs || 150;

    const memoryBufferReference = useRef({
        tapsAccumulated: 0,
        dispatchTimerId: null,
        isCurrentlySending: false
    });

    const isPlayerAllowedToTap = Boolean(
        userZone &&
        activeMatchIdentifier &&
        !winnerZone &&
        currentPhase.toUpperCase() === 'RUNNING'
    );

    const flushTapsToBackendAPI = async () => {
        const memoryBuffer = memoryBufferReference.current;

        if (memoryBuffer.dispatchTimerId) {
            clearTimeout(memoryBuffer.dispatchTimerId);
            memoryBuffer.dispatchTimerId = null;
        }

        if (memoryBuffer.isCurrentlySending || memoryBuffer.tapsAccumulated <= 0 || !activeMatchIdentifier || !userZone) return;

        const tapsToDispatch = memoryBuffer.tapsAccumulated;
        memoryBuffer.tapsAccumulated = 0;
        memoryBuffer.isCurrentlySending = true;

        try {
            await AddTapsToRunToGoalV2Zone({
                matchIdentifier: activeMatchIdentifier,
                zoneIdentifier: userZone,
                tapsObtained: tapsToDispatch
            });
        } catch {
            memoryBuffer.tapsAccumulated += tapsToDispatch;
        } finally {
            memoryBuffer.isCurrentlySending = false;
        }
    };

    const handleScreenTap = () => {
        if (!isPlayerAllowedToTap) return;

        const memoryBuffer = memoryBufferReference.current;
        memoryBuffer.tapsAccumulated++;

        if (memoryBuffer.tapsAccumulated >= tapsBatchSize) {
            if (memoryBuffer.dispatchTimerId) {
                clearTimeout(memoryBuffer.dispatchTimerId);
                memoryBuffer.dispatchTimerId = null;
            }
            flushTapsToBackendAPI();
            return;
        }

        if (!memoryBuffer.dispatchTimerId) {
            memoryBuffer.dispatchTimerId = setTimeout(() => {
                memoryBuffer.dispatchTimerId = null;
                flushTapsToBackendAPI();
            }, minimumFlushTimeMilliseconds);
        }
    };

    // Para La Moderna.
    // Reenviar a X página web 2 segundos después de finalizar el juego
    // useEffect(() => {
    //     let redirectTimer;

    //     if (currentPhase.toUpperCase() === 'FINISHED') {
    //         const delayTimeMs = config?.redirectDelayMs || 2000;
    //         const targetUrl = config?.redirectUrl || 'https://www.amazon.com.mx/stores/LaModerna/page/3B3A751A-86E7-4567-B1F2-F1744BAE4A89?lp_asin=B081RJ';

    //         redirectTimer = setTimeout(() => {
    //             window.location.href = targetUrl;
    //         }, delayTimeMs);
    //     }

    //     return () => {
    //         if (redirectTimer) clearTimeout(redirectTimer);
    //     }
    // }, [currentPhase, config]);

    // Función segura para armar el texto del ganador evitando "Codito y Codito"
    const renderWinnerText = (winnerRaw) => {
        // if (winnerRaw === 'tie') return '¡LA CARRERA TERMINÓ EN EMPATE!';
        if (winnerRaw === 'tie') return '¡Ha habido un empate!';

        if (winnerRaw.startsWith('tie_partial:')) {
            const tiedZones = winnerRaw.split(':')[1].split(' y ');
            // Traducimos cada zona sin el paréntesis de rol
            const uniqueAliases = [...new Set(tiedZones.map(z => getVisualZoneNameWithoutRole(z).toUpperCase()))];
            //return `¡EMPATARON LAS ZONAS ${uniqueAliases.join(' Y ')}!`;
            return `¡Empataron las zonas ${uniqueAliases.join(' y ')}!`;
        }

        //return `¡LA ZONA GANADORA ES ${getVisualZoneName(winnerRaw).toUpperCase()}!`;
        return `¡La zona ganadora es ${getVisualZoneNameWithoutRole(winnerRaw).toUpperCase()}!`;
    };


    return (
        <div className="gfan">
            <div className='gfan__background'>
                <img src='/img/games/runtogoal/fondo-1.png' className='gfan__background__Image' alt="Fondo" />
            </div>

            <header className="container Fan__Goal__GameHeader">
                <div className="w-100 d-flex justify-content-end">
                    <div className="text-end mt-3 me-3">
                        <p className="gfan__controls__who mb-0 text-white font-weight-bold" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.8)' }}>
                            TU ZONA:
                        </p>
                        <h4 className="text-uppercase text-warning fw-bold" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.9)' }}>
                            {/* APLICAMOS LA MÁSCARA AL NOMBRE DE LA ZONA AQUÍ (CON ROL LOCAL/VISITANTE) */}
                            {getVisualZoneNameWithRole(userZone) || 'No Asignada'}
                        </h4>
                    </div>
                </div>
            </header>

            <div className='gfan__controls'>
                {winnerZone && (
                    <p className="gfan__controls__tap__Text"> {/* text-center px-3   fontSize: '1.5rem', lineHeight: '1.2' */}
                        {renderWinnerText(winnerZone)}
                    </p>
                )}

                {!winnerZone && (
                    <>
                        {isPlayerAllowedToTap
                            ? <p className='gfan__controls__tap__Text'>¡Corre! Haz tap en el botón</p> // font-weight-bold
                            : <p className='gfan__controls__tap__Text'>¡Prepárate para correr!</p>
                        }
                    </>
                )}

                <button
                    className={`gfan__controls__tap ${isPlayerAllowedToTap ? '' : 'gfan__controls__tap--disabled'}`}
                    onClick={handleScreenTap}
                    onTouchStart={handleScreenTap}
                >
                    {/* Daikin */}
                    {/* <img src='/img/games/runtogoal/daikin/balon.png' className='gfan__controls__tap__image' alt="Botón Tap" draggable="false" /> */}

                    {/* La Moderna */}
                    {/* <img src='/img/games/runtogoal/la-moderna/balon.png' className='gfan__controls__tap__image' alt="Botón Tap" draggable="false" /> */}
                    
                    {/* Normal */}
                    <img src='/img/games/runtogoal/balon.png' className='gfan__controls__tap__image' alt="Botón Tap" draggable="false" />

                    {/* Carrera Atleti */}
                    {/* <img src='/img/games/runtogoal/copa-academias-adsl/tap.png' className='gfan__controls__tap__image' alt="Botón Tap" draggable="false" /> */}
                </button>
            </div>

            <div className='Fan__Goal__Footer'>
                <p className='FooterCredits'>Hecho con ♥ por Interaktia | 2026</p>
            </div>
        </div>
    );
};

export { GoalV2 };